import { render } from "./resend-gift-message.vue?vue&type=template&id=78895f70&ts=true"
import script from "./resend-gift-message.vue?vue&type=script&lang=ts"
export * from "./resend-gift-message.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__